export const requestLocationPermission = () => {
    return new Promise((resolve, reject) => {

        if (!navigator.geolocation) {
            console.warn("Geolocation not supported");
            return reject("NOT_SUPPORTED");
        }

        navigator.geolocation.getCurrentPosition(
            (position) => {
                const coords = {
                    latitude: position.coords.latitude,
                    longitude: position.coords.longitude
                };

                console.log("📍 Location:", coords);

                resolve(coords);
            },
            (error) => {
                console.error("❌ Location error:", error);

                if (error.code === 1) reject("PERMISSION_DENIED");
                else reject("ERROR");
            },
            {
                enableHighAccuracy: true
            }
        );
    });
};